var constants = require('../constants');
var postUtils = require('../postUtils');

var postListActions = (function() {

    var _requestPostList = function(postListCacheSlug) {
        return {
            type: constants.REQUEST_POST_LIST,
            postListCacheSlug: postListCacheSlug
        };
    };

    var _receivePostList = function(postListCacheSlug, data) {
        return {
            type: constants.RECEIVE_POST_LIST,
            postListCacheSlug: postListCacheSlug,
            data: data
        };
    };

    var _requestPostListFailure = function(postListCacheSlug, error) {
        return {
            type: constants.REQUEST_POST_LIST_FAILURE,
            postListCacheSlug: postListCacheSlug,
            errors: error.data || error
        };
    };

    var _fetchPostList = function(categorySlug, pageNum) {
        pageNum = pageNum || 1;
        var postListCacheSlug = postUtils.getPostListCacheSlug(categorySlug, pageNum);

        return function (dispatch) {
            dispatch(_requestPostList(postListCacheSlug));

            var queryParams = {
                content_type: 'postContainer',
                order: '-fields.publishedDate',
                include: 2
            };

            if(postUtils.isPageNumValid(pageNum)) {
                queryParams.skip = (pageNum - 1) * postUtils.config.pageSize;
                queryParams.limit = postUtils.config.pageSize;
            } else {
                queryParams.limit = postUtils.config.pageMaxSize;
            }

            var categoryID = postUtils.categorySlug2CategoryID[categorySlug];

            if(categoryID){
                queryParams['fields.category.sys.id'] = categoryID;
            }

            return postUtils.contentfulClient.getEntries(queryParams).then(function (entries) {
                var parsedEntries = postUtils.contentfulClient.parseEntries(entries);
                parsedEntries.items.forEach(function(item){
                    item.fields.clientExt_description = postUtils.extractDescriptionFromPostContainer(item);
                });
                return dispatch(_receivePostList(postListCacheSlug, parsedEntries));
            }).catch(function(error){
                dispatch(_requestPostListFailure(postListCacheSlug, error.response || error.message || ''));
            });
        };
    };

    var _shouldFetchPostList = function(postListCacheSlug, state) {
        if (state.postList[postListCacheSlug] && state.postList[postListCacheSlug].data && Object.keys(state.postList[postListCacheSlug].data).length !== 0) {
            return false;
        } else {
            return true;
        }
    };

    var _fetchPostListIfNeeded = function(categorySlug, pageNum) {
        var postListCacheSlug = postUtils.getPostListCacheSlug(categorySlug, pageNum);

        return function(dispatch, getState) {
            if (_shouldFetchPostList(postListCacheSlug, getState())) {
                return dispatch(_fetchPostList(categorySlug, pageNum));
            }
        };
    };

    return {
        fetchPostListIfNeeded: _fetchPostListIfNeeded
    };
})();

module.exports = postListActions;



// WEBPACK FOOTER //
// ./src/common/modules/posts/actions/postList.js